module.exports = __webpack_public_path__ + "static/media/NoResults.8afe3531.svg";